import { css } from '../styled';
import { color, transition } from '../theme';

export const withLinkStyle = css`
        cursor: pointer;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;
        color: ${color('background.action.primary.default')};
        transition: color ${transition('default')};
        background-color: transparent;
        padding: 0;
        border: none;
    
        &:hover,
        &:focus {
            color: ${color('background.action.primary.hover')};
        }
        &:active {
            color: ${color('background.action.primary.pressed')};
        }
        &:active:hover {
            color: ${color('background.action.primary.pressed')};
        }
    `;
